module.exports = __webpack_public_path__ + "media/packs/images/flags/NZ-6ee8eb6a35045d905c64e227ee99dfde.png";